import type { Theme } from '@vfuk/core-themes'

import type { ParagraphTheme } from './Paragraph.theme.types'

const defaultTheme = (theme: Theme): ParagraphTheme => {
  return {
    appearance: {
      primary: {
        color: theme.color.monochrome6.default,
        inverse: {
          color: theme.inverseColor.monochrome6.default,
        },
      },
      secondary: {
        color: theme.color.monochrome5.default,
        inverse: {
          color: theme.inverseColor.monochrome5.default,
        },
      },
    },
  }
}

export default defaultTheme
